/**
 * Csv Schema of MotoristaCancelamentoCarga
 * @author Simpli CLI generator
 */
import {Helper, Schema, FieldSet} from 'simpli-web-sdk'
import {MotoristaCancelamentoCarga} from '@/model/resource/MotoristaCancelamentoCarga'

/* TODO: review generated schema */
export class CsvMotoristaCancelamentoCargaSchema extends Schema {
  readonly name = 'CsvMotoristaCancelamentoCarga'

  readonly fieldSet: FieldSet<MotoristaCancelamentoCarga> = {
    idCancelamentoPk: schema => schema.model.idCancelamentoPk,
    carga: schema => schema.model.carga?.$id ?? null,
    motorista: schema => schema.model.motorista?.$id ?? null,
    data: schema => Helper.datetime(schema.model.data),
  }
}
